import React, { useState, useEffect } from 'react'
import Typography from '@mui/material/Typography'
import { useNavigate } from 'react-router-dom'
import { useHomeStyles } from '../styles/home.styles'
import { CardMedia, Divider } from '@mui/material'
import Card from '@mui/material/Card'
import CardActions from '@mui/material/CardActions'
import CardContent from '@mui/material/CardContent'
import { Link } from '@material-ui/core'
import { useTheme } from '@mui/material/styles' // Importação necessária para acessar os breakpoints

export default function CardQuickGuide({ title, icon, path, subtitle, image }: any) {
  const navigate = useNavigate()
  const theme = useTheme() // Usando o hook useTheme para acessar os breakpoints
  const classes = useHomeStyles()

  const handleNavigate = (path: any) => {
    navigate(path)
  }

  return (
    <Card 
      className={classes.containerCardQuickGuide}
      onClick={() => handleNavigate(path)}
    >
      <CardContent>
        {icon}
        <Typography
          variant="h4"
          component="div"
          className={classes.titleCardQuickGuide}
          sx={{ fontWeight: 700,
            [theme.breakpoints.between('xs', 'lg')]: { 
              fontSize: '24px', // Ajustando o tamanho de fonte em telas menores ou iguais a 'sm'
            },
           }}
        >
          {title}
        </Typography>
        <Divider className={classes.dividerCardQuickGuide} />
        <Typography variant="subtitle1" className={classes.dateCardQuickGuide} 
          sx={{ padding: '3px', marginRight: 5,
            [theme.breakpoints.between('xs', 'lg')]: {
              fontSize: '16px', // Ajustando o tamanho de fonte em telas menores ou iguais a 'sm'
            },
          }}>
          {subtitle}
        </Typography>
      </CardContent>   
      <CardMedia
        component="img"
        sx={{ width: 225,
          [theme.breakpoints.down('md')]: { 
            width: '95%', 
            height: '100%',
            borderRadius: 3,          
          },
          [theme.breakpoints.between('md', 'lg')]: { 
            width: '92%', 
            height: '40%',
            borderRadius: 3,          
          },
          [theme.breakpoints.between('lg', 'xl')]: { 
            width: '92%', 
            height: '48%',
            borderRadius: 3,          
          },
        }}
        image={image}        
      /> 
      <CardActions>
      </CardActions>
    </Card>
  )
}